import { ReactElement } from 'react';
import styles from '@/styles/components/shade-loding.module.less';
import { useTranslation } from '@/services';
import TokenName from '../token/TokenName';
const AddLiquidityLoad = (props: AddLiquidityData): ReactElement => {
    const { t } = useTranslation('common', 'shade');
    return (
        <div className={styles['mint']}>
            {t('liquidity.add')}&nbsp;
            <TokenName token={props.tokenA} /> amount is {props.tokenANumber}
            <br />
            <TokenName token={props.tokenB} /> amount is {props.tokenBNumber}
            <br />
            {t('liquidity.fee')} &nbsp;{props.fee}
        </div>
    );
};

export default AddLiquidityLoad;
